import { Size } from "./size";

export function VerticalSpacer({ size }: { size: Size }) {
  return <div style={{ marginRight: size, marginLeft: size }} />;
}
